import type { Dispatch, ReactNode, SetStateAction } from 'react'
import { createContext, useContext, useState } from 'react'

interface IProps {
  siteId: string
  setSiteId: Dispatch<SetStateAction<string>>
}

const ConnectionContext = createContext<IProps | null>(null)

export const ConnectionProvider = ({ children }: { children: ReactNode }) => {
  const [siteId, setSiteId] = useState<string>(null)
  return (
    <ConnectionContext.Provider value={{ siteId, setSiteId }}>
      {children}
    </ConnectionContext.Provider>
  )
}

export const useConnection = () => {
  return useContext(ConnectionContext) as IProps
}
